var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var models;
    (function (models) {
        var StartProcessActionWorkflowBlock = /** @class */ (function (_super) {
            __extends(StartProcessActionWorkflowBlock, _super);
            function StartProcessActionWorkflowBlock(id, label, initialBlock) {
                var _this = _super.call(this, id, 15 /* StartProcessAction */, label) || this;
                _this.svgWidth = 100;
                _this.svgHeight = 40;
                _this.svgScale = 1;
                _this.svgToolbarScale = 0.75;
                _this.width = _this.svgWidth * _this.svgScale;
                _this.height = _this.svgHeight * _this.svgScale;
                _this.xPadding = (_this.blockWidth - _this.width) / 2;
                _this.yPadding = (_this.blockHeight - _this.height) / 2;
                _this.attributes = { id: _this.id, class: "start-process-action-workflow-block", "data-class": "workflowBlock", "data-id": "startProcessAction" };
                _this.isInitialBlock = initialBlock && initialBlock === true;
                return _this;
            }
            StartProcessActionWorkflowBlock.prototype.getBottomPadding = function () {
                return this.yPadding;
            };
            StartProcessActionWorkflowBlock.prototype.getTopPadding = function () {
                return this.yPadding;
            };
            StartProcessActionWorkflowBlock.prototype.getLeftPadding = function () {
                return this.xPadding;
            };
            StartProcessActionWorkflowBlock.prototype.getRightPadding = function () {
                return this.xPadding;
            };
            StartProcessActionWorkflowBlock.prototype.getMyCenterPoint = function (gridCoordinate) {
                var xOffset = (gridCoordinate.x * this.blockWidth);
                var yOffset = (gridCoordinate.y * this.blockHeight);
                return new models.Coordinate(this.blockWidth / 2 + xOffset, this.blockHeight / 2 + yOffset);
            };
            StartProcessActionWorkflowBlock.prototype.draw = function (paper, coordinate) {
                var xOffset = (coordinate.x * this.blockWidth) + this.xPadding;
                var yOffset = (coordinate.y * this.blockHeight) + this.yPadding;
                var entireBlock = this.drawEntireBlock(paper, coordinate);
                var centerPoint = this.getMyCenterPoint(coordinate);
                this.svgElement = paper.rect(xOffset, yOffset, this.width, this.height, 20, 20);
                this.svgElement.attr(this.attributes);
                var label = this.label ? this.label : models.WorkflowBlockManager.getWorkflowBlockNameByType(this.type);
                this.standardLabel = paper.text(centerPoint.x, centerPoint.y + 5, label);
                this.standardLabel.attr({ class: "text" });
                this.drawOptions(paper, coordinate);
                var stateGroup = paper.group(entireBlock, this.svgElement, this.standardLabel, this.deleteImageElement, this.settingsImageElement);
                return stateGroup;
            };
            StartProcessActionWorkflowBlock.prototype.drawForToolbar = function (paper) {
                this.svgElement = paper.rect(2, 20, this.width, this.height, 20, 20);
                this.svgElement.attr(this.attributes);
                var text = paper.text(this.width / 2, this.height / 2 + 25, this.label);
                text.attr({ class: "text" });
                var stateGroup = paper.group(this.svgElement, text);
                return stateGroup;
            };
            StartProcessActionWorkflowBlock.prototype.getDeleteCoordinate = function (coordinate) {
                var x = (coordinate.x * this.blockWidth) + this.xPadding + this.width - this.getIconWidth();
                var y = (coordinate.y * this.blockHeight) + this.yPadding - this.getIconWidth() / 2;
                return new models.Coordinate(x, y);
            };
            StartProcessActionWorkflowBlock.prototype.getSettingsCoordinate = function (coordinate) {
                var x = (coordinate.x * this.blockWidth) + this.xPadding;
                var y = (coordinate.y * this.blockHeight) + this.yPadding - this.getIconWidth() / 2;
                return new models.Coordinate(x, y);
            };
            StartProcessActionWorkflowBlock.prototype.populateDto = function (dto) {
                this.startProcessActionDto = dto;
            };
            StartProcessActionWorkflowBlock.prototype.updateDrawingBasedOnLabelLengths = function () {
                this.trimTextToSize(this.standardLabel, this.width - 10);
            };
            return StartProcessActionWorkflowBlock;
        }(models.SingleOutputWorkflowBlock));
        models.StartProcessActionWorkflowBlock = StartProcessActionWorkflowBlock;
    })(models = warsApp.models || (warsApp.models = {}));
})(warsApp || (warsApp = {}));
